import getVersion from 'system/getVersion'

// note, other headers are computed on the fly
// see onBeforeRequest(), index.es and extjs.es
export default {
  'Accept-language': window.LOCALE, // TODO: goes back to old cms days, prob obsolete
  Accept: 'application/hal+json',
  'smx3-client': getVersion()
}
